import styled from "styled-components";

export const StyledDatePickerWrapper = styled.div`
  .react-datepicker-wrapper {
    display: block;
    width: 100%;
  }

  .react-datepicker__input-container {
    display: block;
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
  }
`;

export const StyledTimezoneWrapper = styled.div`
  flex: 1;
  min-width: 200px;

  .timezone-picker {
    width: 100%;
  }

  .timezone-picker-textfield input {
    height: 38px;
    cursor: pointer;
    padding: 0.375rem 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    width: 100%;
    box-sizing: border-box;
  }

  .timezone-picker-list {
    width: 100%;
    z-index: 9999;
  }
`;
